var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect, useCallback } from 'react';
import { ImageFormat } from 'corgi-types';
import { useGqlLocale } from '../../../../common/hooks/locale';
import { executeQuery } from '../../../../common/gql';
import isWebpSupported from '../../../../common/utils/isWebpSupported';
import { searchSuggestionsQuery, } from '../gql/query/search-suggestions';
var mapSuggestionToItem = function (suggestion) { return (__assign(__assign({}, suggestion), { urlEncoded: "/search?query=" + encodeURIComponent(suggestion.name) })); };
export var useSuggestions = function (_a) {
    var inputValue = _a.inputValue, isEditedByUser = _a.isEditedByUser, searchDebounce = _a.searchDebounce, suggestionsLimit = _a.suggestionsLimit, searchThreshold = _a.searchThreshold;
    var locale = useGqlLocale();
    var _b = __read(useState([]), 2), suggestions = _b[0], setSuggestions = _b[1];
    useEffect(function () {
        var timeout = null;
        var canceled = false;
        var trimmed = inputValue.trim();
        if (isEditedByUser && trimmed.length >= searchThreshold) {
            timeout = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                var variables, _a, response, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 3, , 4]);
                            _a = [{ prefix: trimmed, locale: locale }];
                            return [4 /*yield*/, isWebpSupported()];
                        case 1:
                            variables = __assign.apply(void 0, _a.concat([((_c.sent()) && { format: ImageFormat.WEBP })]));
                            return [4 /*yield*/, executeQuery(searchSuggestionsQuery, variables)];
                        case 2:
                            response = _c.sent();
                            if (!canceled) {
                                setSuggestions(response.suggestions
                                    .slice(0, suggestionsLimit)
                                    .map(mapSuggestionToItem));
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            _b = _c.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); }, searchDebounce);
        }
        return function () {
            clearTimeout(timeout);
            canceled = true;
        };
    }, [
        inputValue,
        isEditedByUser,
        searchThreshold,
        searchDebounce,
        suggestionsLimit,
    ]);
    var clearSuggestions = useCallback(function () { return setSuggestions([]); }, []);
    return { suggestions: suggestions, clearSuggestions: clearSuggestions };
};
